import { createSelector } from 'reselect';
import { MODULE_NAME as conversionModuleName } from '@conversion/constants';
import { MODULE_NAME } from './constants';

const getPropFromModule = (state, ...props) =>
  state.getIn([conversionModuleName, MODULE_NAME, ...props]);

export const getReviews = createSelector(
  state => getPropFromModule(state, 'reviews'),
  reviews => reviews?.toJS(),
);

export const getReviewsCount = createSelector(
  state => getPropFromModule(state, 'reviews'),
  reviews => reviews?.size,
);

export const getIsFetchingReviews = createSelector(
  state => getPropFromModule(state, 'isFetchingReviews'),
  isFetchingReviews => isFetchingReviews,
);

export const getTotal = createSelector(
  state => getPropFromModule(state, 'total'),
  total => total,
);
